import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(() => ({
  tableContainer: {
    flex: 1,
    margin: '24px 2% 0 34px',
  },
  tableActions: {
    display: 'flex',
    justifyContent: 'flex-start',
    paddingLeft: 0,
  },
  confirmationTableActions: {
    display: 'flex',
    justifyContent: 'flex-start',
    paddingLeft: 0,
    marginBottom: '12px',
  },
  mainTable: {
    marginTop: '16px',
    width: 'auto',
    height: '616px',
  },
  grayColumn: {
    backgroundColor: Theme.Colors.Grayscale.Four,
  },
  idColumn: {
    backgroundColor: Theme.Colors.Grayscale.Four,
    color: Theme.Colors.Primary.Base,
  },
  buttonsContainer: {
    display: 'flex',
    gap: '16px',
  },
  confirmationSummaryContainer: {
    backgroundColor: Theme.Colors.Grayscale.Four,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '24px',
    padding: '12px 16px',
    borderRadius: '8px',
    marginTop: '8px',
  },
  confirmationSummaryLeft: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    width: '100%',
  },
  confirmationSearchContainer: {
    width: '320px',
  },
  confirmationSearchInput: {
    marginTop: 0,
    '& .MuiOutlinedInput-input': {
      textAlign: 'left',
      padding: '10px 16px',
      fontSize: '14px',
      fontWeight: 500,
      color: Theme.Colors.Grayscale.SixtyFour,
    },
    '& .MuiInputBase-root': {
      borderRadius: '8px',
      backgroundColor: '#fff',
      height: '40px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: Theme.Colors.Grayscale.ThirtyTwo,
    },
  },
  confirmationSummaryRight: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '24px',
    width: '100%',
    flexWrap: 'wrap',
    marginTop: '16px',
  },
  discountEditorContainer: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '8px',
    marginTop: '4px',
  },
  discountField: {
    width: '150px',
    '& .MuiInputBase-root': {
      backgroundColor: '#fff',
    },
  },
  discountReasonField: {
    minWidth: '320px',
    '& .MuiInputBase-root': {
      backgroundColor: '#fff',
    },
  },
  discountValidationError: {
    color: Theme.Colors.Red.Base,
    fontSize: '12px',
    fontWeight: 500,
  },
  discountModalGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
    marginTop: '12px',
  },
  discountModalRow: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '16px',
    flexWrap: 'nowrap',
  },
  discountModalField: {
    fontWeight: '500 !important',
    width: '220px',
    minWidth: '220px',
    fontSize: '14px',
    display: 'flex',
    '& .MuiInputBase-input': {
      color: Theme.Colors.Grayscale.SixtyFour,
      fontSize: '14px',
      fontWeight: 500,
      padding: '8px 0px !important',
    },
  },
  discountModalReasonField: {
    flex: '0 0 375px',
    minWidth: '375px',
    maxWidth: '375px',
    '& .MuiOutlinedInput-root': {
      height: '40px',
      borderRadius: '8px',
      backgroundColor: '#fff',
    },
    '& .MuiOutlinedInput-input': {
      padding: '10px 14px',
      fontSize: '14px',
      fontWeight: 500,
      color: Theme.Colors.Grayscale.SixtyFour,
    },
    '& .MuiInputLabel-outlined': {
      fontSize: '14px',
    },
    '& .MuiInputBase-root': {
      backgroundColor: '#fff',
    },
  },
  discountModalPaper: {
    width: '700px',
    maxWidth: 'calc(100% - 64px)',
    minHeight: 'unset',
  },
  discountModalContent: {
    overflowY: 'visible',
    padding: '16px 24px',
  },
  titleBlue: {
    color: Theme.Colors.Primary.Base,
    fontWeight: 600,
    borderBottom: `1px solid ${Theme.Colors.Grayscale.Twelve}`,
    marginBottom: '4px',
  },
  discountModalActions: {
    padding: '8px 24px 16px',
    gap: '8px',
  },
  confirmationSelectedLabel: {
    fontSize: '16px',
    fontWeight: 600,
    color: Theme.Colors.Grayscale.SixtyFour,
    whiteSpace: 'nowrap',
  },
  confirmationSelectedValue: {
    color: Theme.Colors.Primary.Base,
    fontWeight: 700,
  },
  confirmationTotalLabel: {
    fontSize: '16px',
    fontWeight: 600,
    color: Theme.Colors.Grayscale.SixtyFour,
    whiteSpace: 'nowrap',
    '& span': {
      fontWeight: 700,
      marginLeft: '4px',
    },
  },
  confirmationSearchIcon: {
    color: Theme.Colors.Grayscale.ThirtyTwo,
  },
}))
